"use client";
import Image from "next/image";
import GoBackButton from "./go-back-components/go-back-button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";

type BannerProps = {
  id?: string;
  title: string;
  titleYellow: string;
  description: string;
  imageUrl?: string;
  imageAlt?: string;
  goBackButton?: boolean;
  date?: string;
  projectType?: string;
};

export function Banner({
  id,
  title,
  titleYellow,
  description,
  imageUrl,
  imageAlt,
  goBackButton,
  date,
  projectType,
}: BannerProps) {
  const [loaded, setLoaded] = useState(false);

  return (
    <section id={id} className="header2 flex flex-col items-center w-full">
      <article className="relative w-full">
        {imageUrl && imageAlt ? (
          <Image
            src={imageUrl}
            alt={imageAlt}
            priority
            className={`w-full h-lvh object-cover transition-opacity duration-500 ${
              loaded ? "opacity-100" : "opacity-0"
            }`}
            width={1000}
            height={1000}
            onLoad={() => setLoaded(true)}
          />
        ) : (
          ""
        )}
        <div className="absolute inset-0 bg-gradient-to-b from-background-grey via-background-grey/70 to-background-grey z-10" />
        <div className="absolute inset-0 z-10 flex flex-col justify-center p-5 max-w-4xl mx-auto gap-4 text-left">
          {goBackButton ? <GoBackButton /> : ""}

          <h1>
            {title} <span className="text-primary-yellow">{titleYellow}</span>
          </h1>
          <p>{description}</p>
          <p className="text-end text-sm">
            {projectType} {date && projectType ? "·" : ""} {date}
          </p>
        </div>
        <FontAwesomeIcon
          className="absolute bottom-1/6 right-1/2 z-20 text-2xl animate-bounce"
          icon={faChevronDown}
        />
      </article>
    </section>
  );
}

/**
 * <FontAwesomeIcon
          className="absolute fa-xl w-full bottom-1/8 z-10 motion-safe:animate-bounce pt-12"
          icon={faAnglesDown}
        />
 */
